<template>
    <Modal width="800" v-model="show" :title="title + '被试档案'" @on-cancel="onCancel(false)">
        <div class="d-block" v-if="show">
            <Divider>基础信息</Divider>
            <Form class="mt-xs" :label-width="80">
                <FormItem label="头像" v-if="false">
                    <Upload :data="[user.avatar]" type="image" kind="avatar" :size="1" @change="onUpload"/>
                </FormItem>
                <Row :gutter="16">
                    <Col span="12">
                        <FormItem label="姓名" ver>
                            <Input clearable v-model="user.name"/>
                        </FormItem>
                        <FormItem label="出生日期" ver>
                            <DatePicker clearable class="width-all" type="date" v-model="user.birthdayText"/>
                        </FormItem>
                        <FormItem label="联系电话" ver>
                            <Input clearable v-model="user.phone"/>
                        </FormItem>                       
                    </Col>
                    <Col span="12">
                        <FormItem label="性别" ver>
                            <Select clearable v-model="user.sex">
                                <Option :value="it.value" v-for="(it, i) in $common.sex" :key="i">{{ it.text }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="身份证号">
                            <Input clearable v-model="user.idCard"/>
                        </FormItem>
                        <FormItem label="用户ID">
                            <Input clearable v-model="user.hospitalId"/>
                        </FormItem> 
                    </Col>
                    <Col span="24" class="mt-md">
                        <FormItem label="所属区域" ver>
                            <Region :data="user.regionText" :name="user.regionNameText"/>
                        </FormItem>
                        <FormItem label="详细地址" ver>
                            <Input clearable v-model="user.address"/>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="d-block mt-md" v-for="(item, index) in user.parents" :key="index" v-if="show">
            <Divider>{{ item.relation == 1 ? '父亲' : '母亲' }}</Divider>
            <Form class="mt-xs" :label-width="80">
                <Row :gutter="16">
                    <Col span="12">
                        <FormItem label="姓名">
                            <Input clearable v-model="item.name" @on-clear="onParentsField('name', index)"/>
                        </FormItem>
                        <FormItem label="出生日期">
                            <DatePicker clearable class="width-all" type="date" v-model="item.birthdayText" @on-clear="onParentsField('birthdayText', index)"/>
                        </FormItem>
                        <FormItem label="职业">
                            <Select clearable v-model="item.occupation" placeholder="" @on-clear="onParentsField('occupation', index)">
                                <Option :value="it.value" v-for="(it, i) in $common.occupation" :key="i">{{ it.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话">
                            <Input clearable v-model="item.phone" @on-clear="onParentsField('phone', index)"/>
                        </FormItem>
                        <FormItem label="文化程度">
                            <Select clearable v-model="item.education" placeholder="" @on-clear="onParentsField('education', index)">
                                <Option :value="it.value" v-for="(it, i) in $common.education" :key="i">{{ it.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
        <div slot="footer">
            <Button type="text" @click="onCancel(false)">取消</Button>
            <Button type="primary" @click="onConfirm(user, kind)">确定</Button>
        </div>
    </Modal>
</template>

<script type="text/javascript">
    import Upload from "./Upload";
    import Region from "./Region";

    export default {
        components: {
            Upload, Region
        },
        data () {
            return {
                show: false,
                title: '',
                kind: '',
                user: {},
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initChangeUser');
        },
        async mounted() {
            await this.$bus.on('initChangeUser', async (show, user, kind) => {
                debugger
                console.log('this.initChangeUser---------->', show, user, kind);
                if (!show || !user) return;
                this.show = show;
                this.title = kind === 1 ? '添加' : '编辑';
                if (kind === 1 || !user.parents || user.parents.length === 0){
                    user.parents = [
                        {relation: 1}, // 父亲
                        {relation: 2}, // 母亲
                    ]
                }
                if (kind === 2){
                    user.birthdayText = user.birthday && user.birthday !== '' ? new Date(user.birthday) : '';
                    if (user.region && user.region !== '') {
                        user.regionText = user.region.split(",");
                        await this.$store.commit('initRegionValue', user.regionText);
                    } else {
                        user.regionText = [];
                    }
                    if (user.regionName && user.regionName !== '') {
                        user.regionNameText = user.regionName.split(",");
                        await this.$store.commit('initRegionName', user.regionNameText);
                    } else {
                        user.regionNameText = [];
                    }
                    if (user.parents[0] && user.parents[0].birthday){
                        user.parents[0].birthdayText = new Date(user.parents[0].birthday);
                    }
                    if (user.parents[1] && user.parents[1].birthday){
                        user.parents[1].birthdayText = new Date(user.parents[1].birthday);
                    }
                }
                this.user = user;
                this.kind = kind;
            });
        },
        methods: {
            async onCancel(data){
                this.show = false;
                this.title = '';
                this.kind = '';
                this.user = {};
                await this.$bus.emit('initChangeUserSuccess', data);
            },
            async onConfirm(data, kind){
                debugger
                console.log('this.onConfirm---------->', data, kind);
                // if (!data.avatar || data.avatar === ''){
                //     return await this.$common.alertModel('error', '头像不能为空');
                // }

                if (!data.name || data.name === ''){
                    return await this.$common.alertModel('error', '姓名不能为空');
                }
                if (!data.sex || data.sex === ''){
                    return await this.$common.alertModel('error', '性别不能为空');
                }

                if (!data.birthdayText || data.birthdayText === ''){
                    return await this.$common.alertModel('error', '出生日期不能为空');
                }
                data.birthday = new Date(data.birthdayText).getTime();
                let time_0 = new Date().getTime(); // 当前时间戳ss
                let time_3 = (3 * 30 * 24 * 60 * 60 * 1000); // 3个月时间戳ss
                if ((time_0 - data.birthday) < time_3){
                    return await this.$common.alertModel('error', '出生日期应大于3个月');
                }

                if (!data.idCard || data.idCard === ''){
                    // return await this.$common.alertModel('error', '身份证号不能为空');
                }

                let regex = /^1[3456789]\d{9}$/;
                if (!data.phone || data.phone === '' || !regex.test(data.phone)){
                    return await this.$common.alertModel('error', '联系电话不能为空/格式不正确');
                }

                if ((!data.regionText || data.regionText.length === 0) && this.$store.state.regionValue.length === 0){
                    return await this.$common.alertModel('error', '所属区域不能为空');
                } else if (this.$store.state.regionValue.length < 4){
                    return await this.$common.alertModel('error', '所属区域填写不完整');
                } else {
                    data.region = this.$store.state.regionValue.join(',');
                    // data.regionName = this.$store.state.regionName.join(',');
                }
                if (!data.address || data.address === ''){
                    return await this.$common.alertModel('error', '详细地址不能为空');
                }

                // 如果填了其中一项 --> 则需全部填完整
                let dad = data.parents[0];
                const dad_obj = {
                    name: dad.name,
                    phone: dad.phone,
                    birthdayText: dad.birthdayText,
                    education: dad.education,
                    occupation: dad.occupation,
                }
                let dad_arr = Object.values(dad_obj).filter(el => {
                    if (typeof(el) !== 'undefined' && el !== null && el !== '') {
                        return true
                    }
                })
                debugger
                if (dad_arr.length === 0){
                    data.parents[0].name = '';
                    data.parents[0].phone = '';
                    data.parents[0].birthday = '';
                    data.parents[0].birthdayText = '';
                    data.parents[0].education = '';
                    data.parents[0].occupation = '';
                } else if (dad_arr.length > 0 && dad_arr.length < 5) {
                    return await this.$common.alertModel('error', '父亲信息填写不完整');
                }

                let mom = data.parents[1];
                const mom_obj = {
                    name: mom.name,
                    phone: mom.phone,
                    birthdayText: mom.birthdayText,
                    education: mom.education,
                    occupation: mom.occupation,
                }
                let mom_arr = Object.values(mom_obj).filter(el => {
                    if (typeof(el) !== 'undefined' && el !== null && el !== '') {
                        return true
                    }
                })
                if (mom_arr.length === 0){
                    data.parents[1].name = '';
                    data.parents[1].phone = '';
                    data.parents[1].birthday = '';
                    data.parents[1].birthdayText = '';
                    data.parents[1].education = '';
                    data.parents[1].occupation = '';
                } else if (mom_arr.length > 0 && mom_arr.length < 5) {
                    return await this.$common.alertModel('error', '母亲信息填写不完整');
                }
                for (let i = 0; i < data.parents.length; i++) {
                    let it = data.parents[i];
                    if (it.birthdayText && it.birthdayText !== ''){
                        it.birthday = new Date(it.birthdayText).getTime();
                    }
                }

                let res;
                if (kind === 1){
                    res = await this.$api.postHttp('test/user/add', data);
                }
                if (kind === 2){
                    res = await this.$api.putHttp('test/user/edit', data);
                }
                console.log('this.onConfirm---------->', res);
                if (res.data.code !== 0){
                    return this.$Message.error(res.data.msg);
                }
                this.$Message.success(res.data.msg);
                await this.onCancel(true);
            },

            async onParentsField(field, index){
                debugger
                console.log('this.onParentsField---------->', field, index);
                this.user.parents[index][field] = '';
                this.$forceUpdate();
            },

            async onUpload(data, kind){
                console.log('this.onUpload---------->', data, kind);
                if (kind === 'avatar') this.changeModal.data.avatar = data;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ChangeUser.vue